import { render, staticRenderFns } from "./TypingEffect.vue?vue&type=template&id=13c5194f&scoped=true"
import script from "./TypingEffect.vue?vue&type=script&lang=js"
export * from "./TypingEffect.vue?vue&type=script&lang=js"
import style0 from "./TypingEffect.vue?vue&type=style&index=0&id=13c5194f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c5194f",
  null
  
)

export default component.exports